<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 06: 
                    | Activity Packages 
                h3 Book the activity packages you are interested in.

            .button-wrap
                router-link.button(to="/confirmation") Skip this step

        .event-categories.conference-categories
            activity(v-for="activity in allActivities" :activity="activity" :key="activity.id" @pickedActivity="pickedActivity" @clickedActivity="clickedActivity")

        .button-row
            a.back(href="" @click.prevent="$router.go(-1)") 
                i.fa.fa-angle-left
                | Back

            a.next(href="" :class="{ active: isChecked }" @click.prevent="saveFourthStep") Proceed

        //- popup
        activitypopup(:singleActivity="activity" ref="activityPopup")            

</template>

<script>
    import activity from './Activity';
    import activitypopup from './ActivityPopup';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Activities',
        data() {
            return {
                isChecked: false,
                selectedActivities: []
            }
        },
        components: {
            activity,
            activitypopup
        },
        computed: {
            ...mapGetters(['allActivities', 'activity']),
        },
        methods: {
            ...mapActions(['fetchActivities', 'postFourthStepBooking', 'addToTotal', 'getActivity']),
            clickedActivity(selectedActivity) {
                if(selectedActivity) {
                    this.getActivity(selectedActivity.id).then(() => {
                        this.$refs.activityPopup.toggle();
                    });                    
                }
            },            
            pickedActivity(selectedActivity) {

                if(selectedActivity) {
                    selectedActivity.forEach(m => {
                        if(m.checked == true) {
                            this.isChecked = true;

                            var item = this.selectedActivities.find(n => n.activity_package_id === m.activity_package_id);
                            if(item) { return Object.assign(item, m); }
                            this.selectedActivities.push(m);
                        } else {
                            this.removeItem(this.selectedActivities, 'activity_package_id', m.activity_package_id);                            
                        }
                    });
                }                
            },
            removeItem(array, element, item){
                for(var i in array){
                    if(array[i][element] == item){
                        array.splice(i,1);
                        break;
                    }
                }
            },           
            saveFourthStep() {

                var total = 0;

                this.selectedActivities.forEach(data => {
                    total += parseInt(data.activity_cost); 
                });

                for(var i in this.selectedActivities){
                    delete this.selectedActivities[i].checked;
                    delete this.selectedActivities[i].activity_cost;
                }                

                var bookingData = {
                    "booking_id": parseInt(window.localStorage.getItem('firstStepBookingId')),
                    "activity_packages": this.selectedActivities 
                };

                var totalData = {
                    "type": 'activity',
                    "total": total
                }
                
                //add to main total
                this.addToTotal(totalData);

                this.postFourthStepBooking(bookingData).then(() => {
                    this.$router.push('/confirmation');
                });

            }
        },
        created() {
            this.fetchActivities(window.localStorage.getItem('eventCategoryId')).then(() => {
                if(this.allActivities.length == 0) {
                    this.$router.push('/confirmation');
                }
            });
        }
    }
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_popup-slider.sass"    
</style>


